import { Provider, teamsTheme, Loader, teamsDarkTheme } from "@fluentui/react-northstar";
import { HashRouter as Router, Redirect, Route } from "react-router-dom";
import { useTeamsFx } from "@microsoft/teamsfx-react";
// import { OldTab } from "./oldComponents/OldTab";
import "./App.css";
import { TeamsFxContext } from "./Context";
import { Store } from "./stores/Store";
import { configure } from 'mobx';
import { Tab } from "./components/Tab";

export default function App() {

  const { loading, theme, themeString, teamsfx } = useTeamsFx();
  
  // Add error state logging
  console.log('App render - loading:', loading, 'theme:', themeString, 'teamsfx initialized:', !!teamsfx);

  let store: Store = new Store();
  store.teamsFx = teamsfx;
  store.themeString = themeString;
  store.isMobile = window.innerWidth < 667;
  configure({
    isolateGlobalState: true,
    enforceActions: "never"
  });

  // If TeamsFx fails to load, show error
  if (!loading && !teamsfx) {
    console.error('TeamsFx failed to initialize');
    return (
      <div style={{
        padding: '20px',
        textAlign: 'center',
        fontFamily: 'Arial, sans-serif'
      }}>
        <h2>Failed to initialize Teams</h2>
        <p>Please make sure you're running this app inside Microsoft Teams.</p>
        <button 
          onClick={() => window.location.reload()}
          style={{
            backgroundColor: '#5b5fc7',
            color: 'white',
            border: 'none',
            padding: '10px 20px',
            borderRadius: '4px',
            cursor: 'pointer',
            marginTop: '10px'
          }}
        >
          Retry
        </button>
      </div>
    );
  }
  
  return (
    <TeamsFxContext.Provider value={{ theme, themeString, teamsfx }}>
      <Provider theme={theme || teamsTheme || teamsDarkTheme} styles={{ backgroundColor: "#eeeeee" }}>
        <Router>
          <Route exact path="/">
            <Redirect to="/tab" />
          </Route>
            {loading ? <Loader style={{ margin: 100 }} /> : (<Route exact path="/tab" render={(props) => <Tab store={store} />} />)}
        </Router>
      </Provider>
    </TeamsFxContext.Provider >
  );
}
